module.exports = __webpack_public_path__ + "static/img/sidebar-6.329a2fbf.jpg";